import './confidence-pills.css';
import { ConfidenceValue } from './skill-stats/skill-stats-card';

export const ConfidencePills = ({
  value,
  large = false,
  color,
}: {
  value: ConfidenceValue;
  large?: boolean;
  color: string;
}) => {
  return (
    <span
      className={`skillStatsConfidencePills ${large ? 'large' : ''}`}
      aria-hidden="true"
    >
      {Array.from({ length: 5 }, (_, index) => {
        const isActive = index < value;

        return (
          <span
            key={index}
            className="skillStatsConfidencePill"
            style={{
              backgroundColor: isActive ? color : 'var(--light-surface-secondary, #e4e4e4)',
            }}
          />
        );
      })}
    </span>
  );
};
